module.exports = __webpack_public_path__ + "static/blacknoir-7234761b0d5a546086d28eda0ccee4e0.jpg";